import { tabsAnatomy as i } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers as s, defineStyle as o } from "@chakra-ui/react";
const { defineMultiStyleConfig: c, definePartsStyle: n } = s(i.keys), b = o((t) => {
  const { orientation: e } = t;
  return {
    display: e === "vertical" ? "flex" : "block",
    ".tabs-scrollable": {
      overflowX: "scroll",
      position: "relative",
      overflowY: "visible",
      margin: "-4px -4px",
      padding: "4px 4px"
    },
    ".tabs-scrollable::-webkit-scrollbar": {
      display: "none",
      msOverflowStyle: "none",
      scrollbarWidth: "none"
    }
  };
}), d = o((t) => {
  const { isFitted: e } = t;
  return {
    flex: e ? 1 : void 0,
    transitionProperty: "common",
    transitionDuration: "normal",
    _focusVisible: {
      zIndex: 1,
      boxShadow: "outline"
    },
    _disabled: {
      cursor: "not-allowed",
      opacity: 0.4
    }
  };
}), y = o((t) => {
  const { align: e = "start", orientation: r } = t;
  return {
    justifyContent: {
      end: "flex-end",
      center: "center",
      start: "flex-start"
    }[e],
    flexDirection: r === "vertical" ? "column" : "row"
  };
}), m = o({
  p: 4
}), p = n((t) => ({
  root: b(t),
  tab: d(t),
  tablist: y(t),
  tabpanel: m
})), f = {
  md: n({
    tab: {
      textStyle: "subheading1",
      py: 2,
      px: 4
    }
  })
}, x = n((t) => {
  const { orientation: e } = t, r = e === "vertical", l = e === "vertical" ? "borderStart" : "borderBottom", a = r ? "marginStart" : "marginBottom";
  return {
    tablist: {
      [l]: "2px solid",
      borderColor: "gray.200"
    },
    tab: {
      [l]: "2px solid",
      borderColor: "gray.200",
      [a]: "-2px",
      color: "gray.600",
      _hover: {
        color: "teal.500",
        borderColor: "teal.500"
      },
      _selected: {
        color: "teal.700",
        borderColor: "teal.700"
      },
      _disabled: {
        _active: { bg: "none" }
      }
    }
  };
}), v = c({
  baseStyle: p,
  sizes: f,
  variants: {
    line: x
  },
  defaultProps: {
    size: "md",
    variant: "line",
    colorScheme: "blue"
  }
});
export {
  v as default
};
